var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import SyntheticMouseEvent from './SyntheticMouseEvent';
var SyntheticWheelEvent = /** @class */ (function (_super) {
    __extends(SyntheticWheelEvent, _super);
    function SyntheticWheelEvent(type, params) {
        var _this = _super.call(this, type, params) || this;
        _this.syntheticType = 'wheel';
        _this.deltaMode = params.deltaMode;
        _this.deltaX = params.deltaX;
        _this.deltaY = params.deltaY;
        _this.deltaZ = params.deltaZ;
        _this.normalizeWheel = params.normalizeWheel;
        _this.isFromTouchPad = params.original.wheelDelta % 40 !== 0;
        return _this;
    }
    return SyntheticWheelEvent;
}(SyntheticMouseEvent));
export default SyntheticWheelEvent;
